var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricSummary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/Data/Top2Box/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "54.0097041 84.96 59.2067254 84.96 59.2067254 90.27 57.2172407 88.2372656 51.7360073 93.7961719 48.2848604 90.27 43.0878391 95.58 41.8697872 94.3354688 48.2848604 87.7809375 51.7360073 91.3071094 55.9991888 86.9927344"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Top2Box/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#485159",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#72992E",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 11.8425532,
    y: 18.88,
    width: 200.951489,
    height: 11.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 69.587234,
    y: 84.96,
    width: 99.3208511,
    height: 14.16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 11.8425532,
    y: 41.3,
    width: 77.3778723,
    height: 31.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 97.3046809,
    y: 41.3,
    width: 28.8723404,
    height: 31.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6BBE0B",
    x: 11.8425532,
    y: 83.78,
    width: 23.0978723,
    height: 15.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricSummary);
export default __webpack_public_path__ + "static/media/metric-summary.e2424339cc4f1156e9dc74aee00d32b9.svg";
export { ForwardRef as ReactComponent };